import { render, staticRenderFns } from "./PaymentFailed.vue?vue&type=template&id=5386566a"
import script from "./PaymentFailed.vue?vue&type=script&lang=js"
export * from "./PaymentFailed.vue?vue&type=script&lang=js"
import style0 from "./PaymentFailed.vue?vue&type=style&index=0&id=5386566a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports